import { type formatOrder, type PayinOrder } from '~/entities/payin';

type OrderFormatter = Pick<typeof formatOrder, 'currency' | 'date' | 'publicStatus' | 'status'>;

export const getOrderCopyText = (order: PayinOrder, formatter: OrderFormatter) => {
    const requisite =
        order.requisite?.card?.number ||
        order.requisite?.crypto?.address ||
        order.requisite?.sbp?.phoneNumber ||
        order.requisite?.mobile?.phoneNumber ||
        order.requisite?.bankAccount?.bankAccount;

    return `${order.id?.value}, ${order.amount?.value}${formatter.currency(order.currency)}, ${formatter.date(order.createdAt)}, ${requisite}, ${order.publicStatus ? formatter.publicStatus(order.publicStatus) : 'Неизвестно'}, ${order.status ? formatter.status(order.status) : 'Неизвестно'}`;
};
